import { render, staticRenderFns } from "./m-block-premium-features-stepper.vue?vue&type=template&id=5e34e24d&lang=pug"
import script from "./m-block-premium-features-stepper.vue?vue&type=script&lang=js"
export * from "./m-block-premium-features-stepper.vue?vue&type=script&lang=js"
import style0 from "./m-block-premium-features-stepper.vue?vue&type=style&index=0&id=5e34e24d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports